import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchSpotContactsBCRequest,
} from "../../../../../store/features/actions/targetedReachout/spotContactBattleCardActions";
import "./SpotContactBC.css"; // Optional: move styles here
import { useUser } from "../../../../../context/UserContext";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import ContactDetailsBanner from "./ContactDetailsBanner";
import BattleCardDetails from "./BattleCardDetails";
import { useParams } from "react-router-dom";




function SpotContactBCV2({ contactId ,oppDetails}) {// if contactId does not change no need to reredner
  console.log("SpotContactBCV2",oppDetails)
  const buList  = oppDetails?.map(I=>I?.business_unit)
  const { user } = useUser();
  const dispatch = useDispatch();
  const { clientName, accountName } = useParams();
  const { spotContactBCData, spotContactBCLoading } = useSelector(
    (state) => state.spotContactBCReducer
  );
  const contact = spotContactBCData?.[0];
  const [contactInfoDropDown,setContactInfoDropDown] =  useState({});


  useEffect(() => {
    if (contactId) {
      dispatch(FetchSpotContactsBCRequest({ contactId }));
    }
  }, [contactId, dispatch]);

  console.log("contactInfoDropDown",contactInfoDropDown)

  if (spotContactBCLoading) {
    return <div className="scbc-container" style={{display:"flex",justifyContent:"center",alignItems:"center"}}><GeneratingLoader /></div>;
  }

  return (
    <div className="scbc-container">
      {/* Contact Overview */}
      <div className="battlecard_wrapper">
      <ContactDetailsBanner
        name={contact?.name}
        title={contact?.title}
        company={contact?.organization?.name || contact?.employment_history?.[0]?.organization_name}
        location={contact?.country}
        email={contact?.email}
        linkedin={contact?.linkedin_url}
        decisionMaker={true}
        personaInsights={contactInfoDropDown}
        contactId={contactId}
        phone={contact?.phone}
      />
      </div>
      {/*  prioritizes contact?.organization?.name if not found takes contact?.employment_history?.[0]?.organization_name */}

       {(clientName && accountName) && (
       
          <BattleCardDetails contactName={contact?.name} contactOrg={accountName} linkedInUrl={contact?.linkedin_url} sellerOrg={clientName} contactId={contactId} userId={user?.id} setContactInfoDropDown={setContactInfoDropDown} buList={buList}/>


       )}
    </div>
  );
}

export default React.memo(SpotContactBCV2);
